// frontend/src/components/ESIMPackages/ESIMPackageRow.js
import React from "react";
import {
  TableCell,
  TableRow,
  IconButton,
  Box,
  Typography,
} from "@mui/material";
import { ShoppingCart as CartIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const ESIMPackageRow = ({ pkg, onPurchase }) => {
  const { t } = useTranslation();

  // Helper function to get the full flag URL
  const getFlagUrl = (flagPath) => {
    if (!flagPath) return null;
    if (flagPath.startsWith("http")) return flagPath;

    // Use the static URL from the documentation
    return `https://static.redteago.com${flagPath}`;
  };

  // Get location logo from the package data
  const flagUrl =
    pkg.locationNetworkList?.[0]?.locationLogo ||
    `/img/flags/${pkg.location?.toLowerCase()}.png`;

  return (
    <TableRow>
      <TableCell
        component="th"
        scope="row"
        sx={{
          minWidth: "200px",
          pl: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {flagUrl && (
            <img
              src={getFlagUrl(flagUrl)}
              alt={pkg.locationNetworkList?.[0]?.locationName || pkg.name}
              style={{
                width: 24,
                height: 24,
                objectFit: "cover",
                borderRadius: "2px",
                border: "1px solid rgba(0,0,0,0.1)",
                flexShrink: 0,
              }}
              onError={(e) => {
                console.error("Failed to load flag for:", {
                  package: pkg.name,
                  originalUrl: flagUrl,
                  fullUrl: getFlagUrl(flagUrl),
                });
                e.target.style.display = "none";
              }}
            />
          )}
          <Typography noWrap>{pkg.name}</Typography>
        </Box>
      </TableCell>
      <TableCell align="right">
        {(pkg.price / 10000).toFixed(2)} {t("credits.balance")}
      </TableCell>
      <TableCell align="right">
        {(pkg.volume / (1024 * 1024 * 1024)).toFixed(2)} {t("common.units.gb")}
      </TableCell>
      <TableCell align="right">
        {pkg.duration} {t(`common.units.${pkg.durationUnit.toLowerCase()}`)}
      </TableCell>
      <TableCell align="right">
        $
        {(((pkg.price / pkg.volume) * (1024 * 1024 * 1024)) / 10000).toFixed(2)}
      </TableCell>
      <TableCell align="center">{pkg.speed}</TableCell>
      <TableCell align="center">
        <IconButton
          onClick={() => onPurchase(pkg)}
          size="small"
          title={t("esim.packages.actions.purchase")}
        >
          <CartIcon />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};

export default ESIMPackageRow;
